export default {
    isFetching: false,
    isRequesting: false,
    products: [],
    searchedProducts: {}
};
